import { CANNOT_BE_NEGATIVE_NUMBER_MESSAGE, NUMBER_REQUIRED_MESSAGE } from '../constants/ValidationMessagesConstants';

export const nonNegativeNumberValidator = (value: any) => {
    if (!value && value !== 0) {
        return;
    } else if (Number.isNaN(value)) {
        return NUMBER_REQUIRED_MESSAGE;
    } else if (value < 0) {
        return CANNOT_BE_NEGATIVE_NUMBER_MESSAGE;
    }
};
